import React, { Component } from 'react';
import { connect } from 'react-redux';
import { searchForParkingSpot } from 'app/actions/home-traveler';
import ParkingSpotSearchField from 'mz-ui-kit/form/ParkingSpotSearchField';
import TranslatedField from 'app/components/common/TranslatedField';
import DateField from 'mz-ui-kit/form/DateField';
import TimeField from 'mz-ui-kit/form/TimeField';
import Button from 'mz-ui-kit/core/Button';
import Row from 'mz-ui-kit/core/Row';
import { FormattedMessage } from 'mz-intl';
import messages from '../messages.intl';
import { getActiveLanguage, getActiveCurrency } from 'app/sagas/selectors';
import objectToQueryString from 'mz-utils/objectToQueryString';
import {
  Form,
  Fields,
  ButtonWrapper,
  SearchText,
  PickupDateTime,
  Title
} from '../elements';

const BASE_URL = 'https://mozio.travelcar.com/park/';

class ParkingForm extends Component {
  search = (values) => {
    const {
      parking_spot: parkingSpot,
      parking_start_datetime: startDatetime,
      parking_end_datetime: endDatetime,
    } = values;
    const { currency, locale } = this.props;

    const query = {
      language: locale,
      currency,
      country: parkingSpot.country,
      'from-spot-id': parkingSpot.spot_id,
      'from-spot-source': parkingSpot.spot_source,
      'from-spot-latitude': parkingSpot.lat,
      'from-spot-longitude': parkingSpot.lng,
      'from-spot-radius': `${parkingSpot.radius.value} ${parkingSpot.radius.unit}`,
      'from-day': startDatetime.format('YYYY-MM-DD'),
      'from-time': startDatetime.format('HH:mm'),
      'to-day': endDatetime.format('YYYY-MM-DD'),
      'to-time': endDatetime.format('HH:mm'),
      'utm_source': 'ota',
      'utm_medium': 'mozio',
      'utm_campaign': 'park_us',
      'utm_content': parkingSpot.spot_id
    };

    const callback = () => {
      window.open(`${BASE_URL}${objectToQueryString(query)}`, '_blank');
    };

    this.props.searchForParkingSpot(callback);
  };

  render() {

    return (
      <Form onSubmit={this.props.handleSubmit(this.search)}>
        <Title>
          <FormattedMessage message={messages.PARKING_TITLE} />
        </Title>
        <Fields>
          <TranslatedField
            component={ParkingSpotSearchField}
            name="parking_spot"
            appearance="rect"
            label={
              <FormattedMessage message={messages.PARKING_LOCATION} />
            }
          />
          <PickupDateTime>
            <Row wrap="xs">
              <TranslatedField
                component={DateField}
                name="parking_start_datetime"
                appearance="rect"
                fieldAppearnce="desktop"
                label={
                  <FormattedMessage message={messages.PARKING_DROPOFF_DATE} />
                }
                placeholder={
                  <FormattedMessage message={messages.PARKING_DROPOFF_DATE} />
                }
                cleanable={false}
              />
              <TranslatedField
                component={TimeField}
                name="parking_start_datetime"
                appearance="rect"
                fieldAppearnce="desktop"
                label={
                  <FormattedMessage message={messages.PARKING_DROPOFF_TIME} />
                }
                placeholder={
                  <FormattedMessage message={messages.PARKING_DROPOFF_TIME} />
                }
                cleanable={false}
              />
            </Row>
          </PickupDateTime>
          <PickupDateTime>
            <Row wrap="xs">
              <TranslatedField
                component={DateField}
                name="parking_end_datetime"
                appearance="rect"
                fieldAppearnce="desktop"
                label={
                  <FormattedMessage message={messages.PARKING_PICKUP_DATE} />
                }
                placeholder={
                  <FormattedMessage message={messages.PARKING_PICKUP_DATE} />
                }
                cleanable={false}
              />
              <TranslatedField
                component={TimeField}
                name="parking_end_datetime"
                appearance="rect"
                fieldAppearnce="desktop"
                label={
                  <FormattedMessage message={messages.PARKING_PICKUP_TIME} />
                }
                placeholder={
                  <FormattedMessage message={messages.PARKING_PICKUP_TIME} />
                }
                cleanable={false}
              />
            </Row>
          </PickupDateTime>
        </Fields>
        <ButtonWrapper>
          <Button
            TextWrapper={SearchText}
            color="yellow"
            type="submit"
            onClick={this.props.handleSearchButtonClick}
            fullWidth
          >
            <FormattedMessage message={messages.SEARCH} />
          </Button>
        </ButtonWrapper>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  currency: getActiveCurrency(state),
  locale: getActiveLanguage(state).split('_')[0]
});

export default connect(mapStateToProps, { searchForParkingSpot })(ParkingForm);
